import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet, apiPost, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const loadMe = useCallback(async () => {
    if (!getToken()) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const me = await apiGet("/auth/me");
      setUser(me);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onUnauthorized = () => setUser(false);
    window.addEventListener("amelprod-unauthorized", onUnauthorized);
    return () => window.removeEventListener("amelprod-unauthorized", onUnauthorized);
  }, [loadMe]);

  const login = async (email, password) => {
    const { token, user: u } = await apiPost("/auth/login", { email, password });
    setToken(token);
    setUser(u);
    return u;
  };

  const logout = () => {
    setToken(null);
    setUser(false);
  };

  const isAdmin = !!user && user.rol === "admin";
  const canAccess = (ecran) => isAdmin || (!!user && !!(user.permisiuni || {})[ecran]);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, isAdmin, canAccess, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
};
